import request from '../utils/request';

export function getAccountList(params) {
    return request({
        url: '/system/account/list',
        method: 'get',
        params
    });
}

export function saveAccount(data) {
    return request({
        url: '/system/account/save',
        method: 'post',
        data
    });
}

export function getRoleList(params) {
    return request({
        url: '/system/role/list',
        method: 'get',
        params
    });
}

export function saveRole(data) {
    return request({
        url: '/system/role/save',
        method: 'post',
        data
    });
}

export function deleteRole(data) {
    return request({
        url: '/system/role/delete',
        method: 'post',
        data
    });
}
